module.exports = __webpack_public_path__ + "static/img/2.b7bb0d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/eng/2.png
// module id = scKM
// module chunks = 0